<template>
    <div class="mt-5">
        <v-layout row>
            <v-flex md6>
                <h3>{{data.title}}</h3>
            </v-flex>
            <v-flex md6 class="text-md-right">

                <a
                  v-if = "data.export_url"
                  :href = "`${data.export_url}?${serializeQuery()}`"
                  class = "excel-btn"
                  target = "_blank">
                      Download Data
                </a>
            </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex md12 class="text-md-right">
                <div class="d-inline-block ml-2" v-for="(item,index) in searcheable">
                    <v-text-field
                            v-model="filter[item]"
                            :placeholder="item"
                            solo
                    >
                    </v-text-field>
                </div>
                <div class="d-inline-block ml-2">
                    <v-btn color="primary" style="height: 50px" @click="getTableData" height="50" round>Filter</v-btn>
                </div>
            </v-flex>
        </v-layout>
        <v-data-table
                :headers="headers"
                :items="tableData"
                :hide-actions="true"
                :loading = "isLoading"
                loading-text = "Loading... Please wait"
        >
            <template v-slot:items="props">
                <td class="text-xs-center" v-for="(value, key) in props.item">
                    {{ value }}
                </td>
            </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
            <v-pagination
              v-model="page"
              :length="pages"
              @input="getTableData($event, false)" />
        </div>
    </div>
</template>

<script>
    import common from '../../../utils/common'
    import JsonExcel from 'vue-json-excel'
    export default {
        name: "table",
        components: {
            JsonExcel
        },
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            }
        },
        data () {
            return {
                common,
                headers: [

                    // { text: 'Actions', value: 'name', sortable: false, align: 'center', }
                ],
                tableData: [],
                searcheable: [],
                filter: [],
                page:1,
                pages:1,
                perPage: 5,
                isLoading: false
            }
        },
        mounted() {
            this.getTableData()
        },
        methods: {
            getTableData (e, resetOffset = true) {
                this.isLoading = true
                if (resetOffset) this.page = 1
                console.log(this.filter)
                let filterQuery = common.serialize(this.filter)
                // if(filterQuery) {
                //     this.page = 1
                // }

                this.$http_noauth.get(`${this.data.data_url}?page=${this.page}&per_page=${this.perPage}&${filterQuery}`)
                    .then(response=>{
                        this.tableData =  response.data.data
                        this.searcheable = response.data.searcheable
                        this.pages = response.data.pages
                        this.formatTableHeader()
                        this.isLoading = false
                    })
                    .catch(error=>{
                        this.isLoading = false
                    })
            },
            serializeQuery(query = this.filter) {
                // const clone = { ...this.filter }
                return common.serialize(query)
            },
            formatTableHeader() {
                this.headers = []
                for (let property in this.tableData[0]) {
                    if (this.tableData[0].hasOwnProperty(property)) {
                        this.headers.push(
                            {
                                text: property,
                                align: 'center',
                                sortable: false,
                                value: property
                            },
                        )
                    }
                }
            }
        },
    }
</script>

<style >
    .excel-btn {
        display: inline-block;
        width: auto;
        padding: 10px 19px;
        background: #059BFF;
        color: white;
        border-radius: 37px;
        cursor: pointer;
    }
</style>
